module.exports = "<p>campaign-creation works!</p>\r\n"